import React from "react"

import { AcrissAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"


export default function ReportAcrissField() {
	const {
		filterAcriss,
		setFilterAcrissInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterAcriss, "filterAcriss", object({ filterAcriss: array().nullable() }))

	return <AcrissAutocomplete
		value={filterAcriss}
		onChange={e => setFilterAcrissInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/acriss`}
	/>
}